import { CONVERSATION_TYPE } from './enums';

export const getConversationTitle = (conversation, self) => {
  const otherUser = conversation.users.find(
    (user) => user.userId !== self.id
  )?.user;

  const title =
    conversation.type === CONVERSATION_TYPE.DIRECT_MESSAGE
      ? `${otherUser?.firstname} ${otherUser?.lastname}`
      : conversation.title;

  const avatarFallback = `${otherUser?.firstname
    ?.slice(0, 1)
    .toUpperCase()}${otherUser?.lastname?.slice(0, 1).toUpperCase()}`;

  return { title, avatarFallback };
};
